export var TAG_CLASS_PREFIX = 'Tag';
export var TAG_TYPES = {
  DEFAULT: 'default',
  APPROVED: 'approved',
  DENIED: 'denied',
  NEW: 'new'
};
export var TAG_DELETE_BEHAVIOUR_OPTIONS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  ON_HOVER: 'onHover'
};
export var TAG_STATUS_LABELS = {
  APPROVED: 'Approved',
  DENIED: 'Denied',
  NEW: 'New'
};
export var tagRoot = 'TagRoot';
export var tagCloseIconContainer = 'TagCloseIconContainer';